var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 16.9421V19.9421C22.0011 20.2206 21.944 20.4962 21.8324 20.7514C21.7209 21.0066 21.5572 21.2357 21.352 21.4239C21.1468 21.6122 20.9045 21.7556 20.6407 21.8448C20.3769 21.934 20.0973 21.9671 19.8199 21.9421C16.7428 21.6077 13.7869 20.5562 11.1899 18.8721C8.77376 17.3367 6.72527 15.2882 5.18993 12.8721C3.49991 10.2633 2.44818 7.29306 2.11993 4.20207C2.09494 3.92554 2.12781 3.64683 2.21643 3.38369C2.30506 3.12056 2.4475 2.87876 2.6347 2.67369C2.82189 2.46862 3.04974 2.30478 3.30372 2.19259C3.55771 2.0804 3.83227 2.02233 4.10993 2.02207H7.10993C7.59524 2.01729 8.06572 2.18915 8.43369 2.5056C8.80166 2.82206 9.04201 3.26152 9.10993 3.74207C9.23656 4.70214 9.47138 5.6448 9.80993 6.55207C9.94448 6.90999 9.9736 7.29898 9.89384 7.67295C9.81408 8.04692 9.6288 8.39018 9.35993 8.66207L8.08993 9.93207C9.51349 12.4356 11.5864 14.5085 14.0899 15.9321L15.3599 14.6621C15.6318 14.3932 15.9751 14.2079 16.3491 14.1282C16.723 14.0484 17.112 14.0775 17.4699 14.2121C18.3772 14.5506 19.3199 14.7854 20.2799 14.9121C20.7657 14.9806 21.2093 15.2253 21.5265 15.5996C21.8436 15.9739 22.0121 16.4516 21.9999 16.9421Z",
    stroke: "#5B6490",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3d9218e2f273ee9bea8cea0914e39422.svg";
export { ForwardRef as ReactComponent };